import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import ProductTypeForm from './ProductTypeForm';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import '../ManageUsers/ManageUser.scss';
import axios from 'axios';
import { ProductTypesLoader } from './ProductTypesLoader';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

const FileDownload = require('js-file-download');

class ManageProductTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            productTypeInEdit: {},
            isPopupVisible: false,
            productTypes: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {
        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (productTypesFetched) => {
        this.setState({
            ...this.state,
            productTypes: productTypesFetched,
            isLoading: false
        });

        if (productTypesFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (productTypesFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    edit = (dataItem) => {
        this.setState({
            productTypeInEdit: Object.assign({}, dataItem),
            isPopupVisible: true
        });
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageProductType/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Product categories.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageProductType/DeleteProductType`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete the product type.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    };

    addNew = () => {
        this.setState({
            isPopupVisible: true,
            productTypeInEdit: {}
        });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "Description", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageProductType/SaveProductType`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the product type.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            }); 
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"productTypes-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading product categories" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.productTypes.total}
                                {...this.state.dataState}
                                {...this.state.productTypes}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageProductTypes/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="Description" title="Description" filter="text" />
                                <Column
                                    field="IsActive"
                                    title="Is Active"
                                    width="150vw"
                                    filterable={true}
                                    filter="boolean"
                                    className="isActive-column"
                                />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <ProductTypesLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <ProductTypeForm
                                dataItem={this.state.productTypeInEdit}
                                save={this.save}
                                cancel={this.cancel}
                            />
                        ) : ""
                    }
                </div>
            </div>

        );
    }
}

export default ManageProductTypes;
